import axios from 'axios'
import {Action} from 'redux'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import {put, takeLatest, takeLeading} from 'redux-saga/effects'
import {APIResponse} from '../../../models/HelperModel'
import {IRFSatuanKerja} from '../../../models/RFSatuanKerja'

interface ActionWithPayload<T> extends Action {
  payload: T
}

const actionTypes = {
  InitRFSatuanKerja: '[Init RF Satuan Kerja] Action',
  SetRFSatuanKerja: '[Set RF Satuan Kerja] Action',
}

const initialRFSatuanKerja: IArrayRFSatuanKerja = {
    rfSatuanKerja: [] as IRFSatuanKerja[],
}

interface IArrayRFSatuanKerja {
  rfSatuanKerja?: IRFSatuanKerja[]
}

export const reducer = persistReducer(
  {storage: storage, key: 'rf-satuan-kerja', whitelist: ['rfSatuanKerja']},
  (
    state: IArrayRFSatuanKerja = initialRFSatuanKerja,
    action: ActionWithPayload<IArrayRFSatuanKerja>
  ) => {
    switch (action.type) {
      case actionTypes.InitRFSatuanKerja: {
        return {...state, rfSatuanKerja: [] as IRFSatuanKerja[]}
      }
      case actionTypes.SetRFSatuanKerja: {
        return {...state, rfSatuanKerja: action.payload.rfSatuanKerja}
      }

      default:
        return state
    }
  }
)

export const actions = {
  initRFSatuanKerja: () => ({type: actionTypes.InitRFSatuanKerja}),
  SetRFSatuanKerja: (RFSatuanKerja: IRFSatuanKerja[]) => ({
    type: actionTypes.SetRFSatuanKerja,
    payload: {rfSatuanKerja: RFSatuanKerja},
  }),
}

export function* saga() {
  yield takeLatest(
    actionTypes.InitRFSatuanKerja,
    function* requestSatuanKerja({
      type,
      payload,
    }: {
      type: typeof actionTypes.SetRFSatuanKerja
      payload: {rfSatuan: IRFSatuanKerja[]}
    }) {
      const {
        data: {data: a},
      } = yield getRFSatuanKerja()
      yield put(actions.SetRFSatuanKerja(a))
    }
  )
}

function getRFSatuanKerja() {
  const API_URL = process.env.REACT_APP_API_URL
  const RF_SATUAN_KERJA = `${API_URL}/satuankerja`
  return axios.get<APIResponse<IRFSatuanKerja[]>>(RF_SATUAN_KERJA)
}
